<nb-layout>
  <nb-layout-column>
    <app-custom></app-custom>
  </nb-layout-column>
</nb-layout>
